import { render } from "./delievryReport.vue?vue&type=template&id=72385902"
import script from "./delievryReport.vue?vue&type=script&lang=js"
export * from "./delievryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__